export default __webpack_public_path__ + "static/media/gallery_logo.e39553c7.png";